import { render, staticRenderFns } from "./authModal.vue?vue&type=template&id=78d519bc&scoped=true"
import script from "./authModal.vue?vue&type=script&lang=js"
export * from "./authModal.vue?vue&type=script&lang=js"
import style0 from "./authModal.vue?vue&type=style&index=0&id=78d519bc&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d519bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78d519bc')) {
      api.createRecord('78d519bc', component.options)
    } else {
      api.reload('78d519bc', component.options)
    }
    module.hot.accept("./authModal.vue?vue&type=template&id=78d519bc&scoped=true", function () {
      api.rerender('78d519bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/src/components/authModal.vue"
export default component.exports